import { FEATURE_FLAGS } from 'dashboard/featureFlags';
import {
  captureConversationAccess,
  captureConversationSession,
  listedConversationRecords,
} from './conversationReads';

export const kanbanEnabled = rootGetters =>
  !!rootGetters.getCurrentAccountId &&
  !!rootGetters.getCurrentRole &&
  rootGetters['accounts/isFeatureEnabledonAccount'](
    rootGetters.getCurrentAccountId,
    FEATURE_FLAGS.KANBAN
  );

const captureRequest = (context, current) => {
  const version = context.state.readVersion;
  return () =>
    current() &&
    version === context.state.readVersion &&
    kanbanEnabled(context.rootGetters);
};

export const captureKanbanAccess = context =>
  captureRequest(context, captureConversationAccess(context));

// Pipeline configuration is shared by every account member. Conversation
// access revisions do not invalidate it; account/session/membership still do.
export const capturePipelineAccess = context =>
  captureRequest(context, captureConversationSession(context));

export const listedKanbanCards = (rootState, records) =>
  listedConversationRecords(rootState, records, card => card.display_id);

export const listedKanbanBoard = (rootState, data) => {
  let removed = 0;
  const lanes = data.lanes.map(lane => {
    const conversations = listedKanbanCards(rootState, lane.conversations);
    const difference = lane.conversations.length - conversations.length;
    removed += difference;
    return {
      ...lane,
      conversations,
      count: Math.max(0, lane.count - difference),
    };
  });
  return {
    ...data,
    lanes,
    meta: {
      ...data.meta,
      total_conversations: Math.max(0, data.meta.total_conversations - removed),
    },
  };
};
